// extracted by mini-css-extract-plugin
export var container = "carouselSection-module--container--d82ce";
export var content = "carouselSection-module--content--88a21";
export var heading = "carouselSection-module--heading--204a9";
export var image = "carouselSection-module--image--6d156";
export var imageHolder = "carouselSection-module--imageHolder--63097";
export var info = "carouselSection-module--info--bd427";
export var link = "carouselSection-module--link--94739";
export var subContainer = "carouselSection-module--subContainer--ade2b";
export var subtitle = "carouselSection-module--subtitle--1b00d";